import graphql from "babel-plugin-relay/macro";

const UserLeaderboardQuery = graphql`
query UserLeaderboardQuery{
  userLeaderboard
}
`

export default UserLeaderboardQuery;